export default __webpack_public_path__ + "static/media/submit-button-on-change.1c4bb4ba.png";